// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2tipI{display:-ms-flexbox;display:flex;grid-gap:16px;gap:16px;grid-gap:1rem;gap:1rem;color:inherit}@media(max-width:1023px){._2tipI{-ms-flex-direction:column;flex-direction:column}}._2tipI:hover{color:inherit}._3Rspx{cursor:pointer}._1g7Ao,._1RzKP{-ms-flex:1 1;flex:1 1}._1RzKP{position:relative;border-radius:.5rem;overflow:hidden}._1RzKP:after{content:\"\";padding-bottom:56.25%;display:block}._1r8VV{position:absolute;-o-object-fit:cover;object-fit:cover;width:100%;height:100%}._1g7Ao{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between}._1fSUy{margin-bottom:.5rem}.snaw2{margin-bottom:.25rem}._1dG_z{color:#595757;font-size:14px;font-size:.875rem;font-weight:300;line-height:23px;line-height:1.4375rem;font-family:var(--base-font)}@media(max-width:767px){._1dG_z{font-size:1rem;line-height:1.625rem}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_2tipI",
	"rootClickable": "_3Rspx",
	"information": "_1g7Ao",
	"thumbnail": "_1RzKP",
	"image": "_1r8VV",
	"content": "_1fSUy",
	"name": "snaw2",
	"frequency": "_1dG_z"
};
module.exports = exports;
